

































































import { ClientAccountDeed } from '@/shared/clients/client-account-deed';
import { ClientAccountDuplicate } from '@/shared/clients/client-account-duplicate';
import { ClientAccountWill } from '@/shared/clients/client-account-will';
import { ClientPowerOfAttorney } from '@/shared/clients/client-power-of-attorney';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { PowerOfAttorneyType } from '@/shared/types/power-of-attorney-type';
import { WillType } from '@/shared/types/will-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');

@Component
export default class ClientDuplicatesTable extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;

    @typesModule.Getter('clientOriginalSourceTypes') private clientOriginalSourceTypes!: Array<ClientOriginalSourceType>;
    @typesModule.Getter('powerOfAttorneyTypes') private powerOfAttorneyTypes!: Array<PowerOfAttorneyType>;
    @typesModule.Getter('willTypes') private willTypes!: Array<WillType>;

    @Prop({ required: true }) public clientDuplicates!: Array<ClientAccountDuplicate & { selected: boolean }>;

    private get clientDuplicateFields(): Array<{}> {
        return [
            { key: 'select', label: '' },
            { key: 'matchPercent', label: 'Match %' },
            { key: 'accountNo', label: 'Account No' },
            { key: 'name', label: 'Name' },
            { key: 'addressLine1', label: 'Address Line 1' },
            { key: 'postcode', label: 'Postcode' },
            { key: 'partnerPractice', label: 'Assigned To' },
            { key: 'originalSource', label: 'Introducer' },
            { key: 'documents', label: 'Documents' },
            { key: 'actions', label: '' },
        ];
    }

    @Watch('clientDuplicates', { deep: true })
    private onClientDuplicatesChanged(): void {
        const selectedDuplicate = this.clientDuplicates.find((d) => d.selected);
        this.$emit('duplicate-changed', selectedDuplicate == null ? null : { ...selectedDuplicate });
    }

    private isDisabled(item: ClientAccountDuplicate & { selected: boolean }): boolean {
        return !item.selected && this.clientDuplicates.some((d) => d.selected);
    }

    private clientFullName(item: ClientAccountDuplicate & { selected: boolean }): string {
        return `${item.firstName != null ? item.firstName.trim() : ''} ${item.lastName != null ? item.lastName.trim() : ''}`;
    }

    private originalSourceDescription(item: ClientAccountDuplicate & { selected: boolean }): string {
        const clientOriginalSourceType = this.clientOriginalSourceTypes.find((type) => type.id === item.originalSourceId!);
        return clientOriginalSourceType != null ? clientOriginalSourceType.value : '';
    }

    private willTypeDescription(will: ClientAccountWill): string {
        const willType = this.willTypes.find((type) => type.id === will.willTypeId);
        return willType == null ? '' : willType.value;
    }

    private powerOfAttorneyTypeDescription(powerOfAttorney: ClientPowerOfAttorney): string {
        const powerOfAttorneyType = this.powerOfAttorneyTypes.find((type) => type.id === powerOfAttorney.powerOfAttorneyTypeId);
        return powerOfAttorneyType == null ? '' : powerOfAttorneyType.value;
    }

    private deedDescription(deed: ClientAccountDeed): string {
        return `Deed - ${deed.addressLine1}, ${deed.postcode}`;
    }
}
